import jQuery from "jquery"
import _once from "lodash/once"

const getHtmlEl = _once(() => jQuery("html"))
const getBodyEl = _once(() => jQuery("body"))

const SIGN_IN_CLASS = "user-signed-in"
const SIGN_OUT_CLASS = "user-signed-out"

const isSignedIn = () => getHtmlEl().hasClass(SIGN_IN_CLASS)
const isSignedOut = () => getHtmlEl().hasClass(SIGN_OUT_CLASS)

const setSignedIn = () => {
  getHtmlEl().removeClass(SIGN_OUT_CLASS).addClass(SIGN_IN_CLASS)
  getBodyEl().removeClass(SIGN_OUT_CLASS).addClass(SIGN_IN_CLASS)
}
const setSignedOut = () => {
  getHtmlEl().removeClass(SIGN_IN_CLASS).addClass(SIGN_OUT_CLASS)
  getBodyEl().removeClass(SIGN_IN_CLASS).addClass(SIGN_OUT_CLASS)
}

export default {
  isSignedIn,
  isSignedOut,
  setSignedIn,
  setSignedOut,
}

export {
  isSignedIn,
  isSignedOut,
  setSignedIn,
  setSignedOut,
}
